import React, { FC } from "react";
import ClassNames from "classnames";
import "./WebdealColorPickerV2.less";

interface Color {
    dedicatedColor: string;
    html?: string;
    id?: string | number;
    name?: string;
    sku?: string;
}

interface WebdealColorButtonProps {
    color: Color;
    id: string;
    selectedColor?: Color;
    setSelectedColor: (color: Color) => void;
}

const WebdealColorButton: FC<WebdealColorButtonProps> = ({ id, setSelectedColor, color, selectedColor }) => {
    const variationClicked = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedColor({
            ...color,
            id,
        });
    };
    const classNames = ClassNames("web-deal-color-picker__color-circle", {
        selected: selectedColor?.dedicatedColor === color.dedicatedColor,
    });

    return (
        <div key={id} onClick={variationClicked} className={classNames} style={{ backgroundColor: color.html }}></div>
    );
};

export default WebdealColorButton;
